import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const ZebraTopLogo = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
    >
      <path
        d='M14.2321 9.66202H19.7221L17.4771 7.41802L17.4681 7.40702H14.5811C16.4681 7.23102 17.9441 5.64402 17.9441 3.71102C17.9441 1.66202 16.2831 -0.000976562 14.2321 -0.000976562V7.41802H14.2301L8.06411 1.26802C7.73711 1.43802 7.42111 1.62202 7.11411 1.82302C6.77711 2.04202 6.45211 2.28102 6.14111 2.53502L11.9791 8.35002V21.12L16.4861 25.626V22.441L14.2321 20.186V9.66202Z'
        fill='currentColor'
      />
      <path
        d='M16.4865 9.67622L16.4755 20.5622H18.7275L18.7395 11.9412L16.4865 9.67622Z'
        fill='currentColor'
      />
      <path
        d='M21.9671 11.9442L24.2201 14.1972H20.9911L18.7401 11.9442H21.9671Z'
        fill='currentColor'
      />
      <path
        d='M9.72451 18.9999V9.30292L4.54651 4.12592C4.06151 4.71792 3.63451 5.35992 3.27751 6.04392L7.47051 10.2369V13.4239L2.38251 8.33492C2.14151 9.23192 2.00951 10.1719 1.99951 11.1409C1.99951 11.1409 9.47151 18.7379 9.72451 18.9999Z'
        fill='currentColor'
      />
      <path
        d='M20.9951 14.2L23.2491 16.454V20.578H20.9951V14.2Z'
        fill='currentColor'
      />
      <path
        d='M27.7568 17.7294H25.5028V20.5784L23.2491 20.578C23.2491 22.628 24.9108 24.2914 26.9608 24.2914C29.0098 24.2914 30.6728 22.6284 30.6728 20.5784L27.7568 17.7294Z'
        fill='currentColor'
      />
      <path
        d='M2.03906 17.5536V14.3666L16.4871 28.8126V31.9996L2.03906 17.5536Z'
        fill='currentColor'
      />
    </svg>
  )
);
